













































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Breadcrumb from '../../components/Breadcrumb.vue';
import ThemeService, { ThemeViewModel } from '../../api/theme';
import { CaliberService, CaliberViewModel } from '../../api/caliber';
import { PagedList } from '../../api/PagedList';

@Component({
  components: {
    Breadcrumb,
  },
})
export default class CaliberIndex extends Vue {
  private breadcrumbData = [{name: '口径库'}];
  private data: PagedList<CaliberViewModel> = new PagedList<CaliberViewModel>();
  private service: CaliberService = new CaliberService();
  private condition: CaliberViewModel = this.service.NewModel;
  private themeData: ThemeViewModel[] = [];
  private themeService: ThemeService = new ThemeService();
  private pageIndex: number = 1;

  private mounted() {
    this.themeService.GetCaliber().then((response: any) => {
      this.themeData = response;
    });
    this.condition.themeID = 0;
    this.search(this.condition, 1);
  }
  private search(condition: CaliberViewModel, page: number) {
    this.pageIndex = page;
    this.service.Search(condition, page).then((response: any) => {
      this.data = response;
    });
  }
  private page_OnChange(val: any) {
    this.search(this.condition, val);
  }
  private filter_OnClick(type: string, value: any) {
    this.condition.themeID = value;
    this.search(this.condition, 1);
  }
  private key_OnChange() {
    this.search(this.condition, 1);
  }
}
